import React from "react";
import { Col, Row, Tabs } from "antd";
import MerchantDashboard from "./merchantDashboard";
import MerchantPermission from "./merchantPermission";
import MerchantInfo from "../card/merchantInfo";
import MerchantSettlements from "./merchantSettlements";
import FeeShareRulePanel from "./feeShareRulePanel";
import SplitHistoryPanel from "./splitHistoryPanel";
import { useAdmin } from "context/adminContext";

const MerchantPanel = () => {
  const { activeMerchantId } = useAdmin();
  const tabs = [
    {
      key: "1",
      label: `Үйлчилгээний эрх`,
      children: <MerchantPermission />,
    },
    {
      key: "2",
      label: `Өндөрлөгөө`,
      children: <MerchantSettlements activeMerchantId={activeMerchantId} />,
    },
    {
      key: "feeShare",
      label: `Тооцоо хуваарилалт`,
      children: <FeeShareRulePanel />,
    },
    {
      key: "splitHistory",
      label: `Split түүх`,
      children: <SplitHistoryPanel />,
    },
    {
      key: "3",
      disabled: true,
      label: `Мерчант дашбоард`,
      children: <MerchantDashboard />,
    },
  ];
  return (
    <div>
      <MerchantInfo />
      <Tabs items={tabs} />
    </div>
  );
};

export default MerchantPanel;
